<!-- Page Header -->
 
<section class="cuspage-hero">
    <div class="cuspage-hero__bg"></div>
    <div class="container">
        <div class="cuspage-hero__content">
             <span class="cuspage-hero__tagline" style="display:none;">
                <i class="icofont-justice-hammer"></i>
                {{ 'signal_tagline' | translate }}
            </span>
            <h1 class="cuspage-hero__title">{{ 'signal_titre' | translate }}</h1>
            <p class="cuspage-hero__sub">{{ 'signal_sous_titre' | translate }}</p>  
        </div>
    </div>
</section>

<!-- Form Section -->
<section class="arp-form-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-9">

        <!-- ── SUCCESS ── -->
        <div *ngIf="submitted" class="arp-success wow fadeInUp">
          <div class="arp-success__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>{{ 'signal_succes_titre' | translate }}</h3>
          <p>{{ 'signal_succes_msg' | translate }}</p>
          <div *ngIf="reference" class="arp-ref-badge">
            <span class="arp-ref-label">{{ 'signal_reference' | translate }}</span>
            <span class="arp-ref-num">{{ reference }}</span>
          </div>
          <div class="arp-success__actions">
            <button class="careox-btn" (click)="reset()">
              <span>{{ 'signal_nouveau' | translate }}</span>
            </button>
            <a routerLink="/" class="careox-btn careox-btn--ghost">
              <span>{{ 'accueil' | translate }}</span>
            </a>
          </div>
        </div>

        <!-- ── FORM ── -->
        <div *ngIf="!submitted">
          <div class="sec-title wow fadeInUp" data-wow-delay="100ms" style="display:none;">
            <span class="sec-title__tagline">{{ 'signal_tagline' | translate }}</span>
            <h3 class="sec-title__title">{{ 'signal_titre' | translate }}</h3>
            <p class="sec-title__text">{{ 'signal_sous_titre' | translate }}</p>
          </div>

          <form class="arp-form wow fadeInUp" data-wow-delay="200ms" (ngSubmit)="onSubmit()" novalidate>

            <div *ngIf="error" class="arp-alert-error">{{ error }}</div>

            <!-- Section 1: Informations du signalant -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke-linecap="round"/>
                </svg>
                {{ 'signal_section_signalant' | translate }}
              </h5>

              <div class="arp-anon-note">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="18" height="18">
                  <path d="M12 1l9 4v6c0 5-3.8 9.3-9 11-5.2-1.7-9-6-9-11V5l9-4z" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ 'signal_anonyme_note' | translate }}</span>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_nom' | translate }} <span class="arp-opt">{{ 'commun_facultatif' | translate }}</span></label>
                    <input type="text" class="form-control arp-input"
                      [(ngModel)]="form.name" name="name"
                      [placeholder]="'signal_nom_ph' | translate">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_telephone' | translate }} <span class="arp-opt">{{ 'commun_facultatif' | translate }}</span></label>
                    <input type="tel" class="form-control arp-input"
                      [(ngModel)]="form.phone" name="phone"
                      [placeholder]="'signal_tel_ph' | translate">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_email' | translate }} <span class="arp-opt">{{ 'commun_facultatif' | translate }}</span></label>
                    <input type="email" class="form-control arp-input"
                      [(ngModel)]="form.email" name="email"
                      [placeholder]="'signal_email_ph' | translate">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group" [class.has-error]="isInvalid('report_type')">
                    <label class="arp-label">{{ 'signal_type' | translate }} <span class="req">*</span></label>
                    <select class="form-control arp-input"
                      [(ngModel)]="form.report_type" name="report_type"
                      (blur)="touch('report_type')">
                      <option value="">{{ 'signal_type_choisir' | translate }}</option>
                      <option *ngFor="let t of reportTypes" [value]="t.value">{{ t.label | translate }}</option>
                    </select>
                    <span *ngIf="isInvalid('report_type')" class="arp-err">{{ 'commun_champ_requis' | translate }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_plateforme' | translate }}</label>
                    <select class="form-control arp-input" [(ngModel)]="form.platform" name="platform">
                      <option value="">{{ 'signal_plateforme_choisir' | translate }}</option>
                      <option *ngFor="let p of platforms" [value]="p.value">{{ p.label | translate }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_url' | translate }}</label>
                    <input type="url" class="form-control arp-input"
                      [(ngModel)]="form.reported_url" name="reported_url"
                      placeholder="https://...">
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="arp-label">{{ 'signal_priorite' | translate }}</label>
                    <div class="arp-priority-row">
                      <label *ngFor="let p of priorityLevels" class="arp-priority-opt" [class.active]="form.priority === p.value">
                        <input type="radio" [(ngModel)]="form.priority" name="priority" [value]="p.value">
                        <span [class]="'arp-priority-chip ' + p.css">{{ p.label | translate }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 2: Détails du signalement -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke-linecap="round"/>
                  <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke-linecap="round"/>
                </svg>
                {{ 'signal_section_details' | translate }}
              </h5>

              <div class="form-group" [class.has-error]="isInvalid('subject')">
                <label class="arp-label">{{ 'signal_objet' | translate }} <span class="req">*</span></label>
                <input type="text" class="form-control arp-input"
                  [(ngModel)]="form.subject" name="subject"
                  (blur)="touch('subject')"
                  [placeholder]="'signal_objet_ph' | translate">
                <span *ngIf="isInvalid('subject')" class="arp-err">{{ 'commun_champ_requis' | translate }}</span>
              </div>

              <div class="form-group" [class.has-error]="isInvalid('description')">
                <label class="arp-label">{{ 'signal_description' | translate }} <span class="req">*</span></label>
                <textarea class="form-control arp-input arp-textarea"
                  [(ngModel)]="form.description" name="description"
                  rows="5" (blur)="touch('description')"
                  [placeholder]="'signal_description_ph' | translate"></textarea>
                <span *ngIf="isInvalid('description')" class="arp-err">{{ 'commun_champ_requis' | translate }}</span>
              </div>

              <div class="form-group">
                <label class="arp-label">{{ 'signal_contenu_signale' | translate }}</label>
                <textarea class="form-control arp-input arp-textarea"
                  [(ngModel)]="form.reported_content" name="reported_content"
                  rows="3"
                  [placeholder]="'signal_contenu_ph' | translate"></textarea>
              </div>
            </div>

            <!-- Section 3: Captures / Preuves -->
            <div class="arp-form__section">
              <h5 class="arp-form__section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke-linecap="round"/>
                </svg>
                {{ 'signal_captures_titre' | translate }}
              </h5>

              <label class="arp-dropzone" [class.arp-dropzone--full]="evidenceFiles.length >= 5">
                <input type="file" multiple accept="image/*,.pdf,.doc,.docx"
                  style="display:none" (change)="onFilesChange($event)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-linecap="round"/>
                </svg>
                <span class="arp-dropzone__label">{{ 'signal_captures_deposer' | translate }}</span>
                <span class="arp-dropzone__hint">{{ 'commun_fichiers_hint' | translate }}</span>
              </label>

              <span *ngIf="evidenceError" class="arp-err d-block mt-2">{{ evidenceError }}</span>

              <div *ngIf="evidenceFiles.length > 0" class="arp-file-list">
                <div *ngFor="let f of evidenceFiles; let i = index" class="arp-file-item">
                  <div class="arp-file-icon">
                    <svg *ngIf="fileIsImage(f)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <path d="M21 15l-5-5L5 21" stroke-linecap="round"/>
                    </svg>
                    <svg *ngIf="!fileIsImage(f)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <div class="arp-file-meta">
                    <span class="arp-file-name">{{ f.name }}</span>
                    <span class="arp-file-size">{{ formatSize(f.size) }}</span>
                  </div>
                  <button type="button" class="arp-file-del" (click)="removeFile(i)">
                    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4">
                      <path d="M4 4l8 8M12 4l-8 8" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Captcha anti-spam -->
            <div class="arp-form__section">
              <app-captcha #captcha [(value)]="captchaAnswer"></app-captcha>
            </div>

            <!-- Actions -->
            <div class="arp-form__actions">
              <button type="button" class="careox-btn careox-btn--ghost" (click)="reset()">
                <span>{{ 'signal_annuler' | translate }}</span>
              </button>
              <button type="submit" class="careox-btn" [disabled]="loading">
                <span *ngIf="loading" class="arp-spinner"></span>
                <span>{{ loading ? ('signal_envoi' | translate) : ('signal_envoyer' | translate) }}</span>
              </button>
            </div>

          </form>
        </div>

      </div>
    </div>
  </div>
</section>
